import { CALL_API } from '../../middleware/api';
import { CALL_INTAKE_V2_API } from '../../middleware/intakeV2Api';
import { getSelectedClientInformation, getSelectedDivisions } from '../../utilities/authUtils';

/* global RSSParser */
import 'rss-parser/dist/rss-parser.min.js';
const rssParser = new RSSParser();

export const GET_BLOG_DATA_REQUEST = 'GET_BLOG_DATA_REQUEST';
export const GET_BLOG_DATA_SUCCESS = 'GET_BLOG_DATA_SUCCESS';
export const GET_BLOG_DATA_FAILURE = 'GET_BLOG_DATA_FAILURE';
export const GET_AUTHORIZATION_CURRENT_PREVIOUS_REQUEST = 'GET_AUTHORIZATION_CURRENT_PREVIOUS_REQUEST';
export const GET_AUTHORIZATION_CURRENT_PREVIOUS_SUCCESS = 'GET_AUTHORIZATION_CURRENT_PREVIOUS_SUCCESS';
export const GET_AUTHORIZATION_CURRENT_PREVIOUS_FAILURE = 'GET_AUTHORIZATION_CURRENT_PREVIOUS_FAILURE';
export const GET_EXPENSES_CURRENT_PREVIOUS_REQUEST = 'GET_EXPENSE_CURRENT_PREVIOUS_REQUEST';
export const GET_EXPENSES_CURRENT_PREVIOUS_SUCCESS = 'GET_EXPENSE_CURRENT_PREVIOUS_SUCCESS';
export const GET_EXPENSES_CURRENT_PREVIOUS_FAILURE = 'GET_EXPENSE_CURRENT_PREVIOUS_FAILURE';
export const GET_EXCEPTIONS_CURRENT_PREVIOUS_REQUEST = 'GET_EXCEPTIONS_CURRENT_PREVIOUS_REQUEST';
export const GET_EXCEPTIONS_CURRENT_PREVIOUS_SUCCESS = 'GET_EXCEPTIONS_CURRENT_PREVIOUS_SUCCESS';
export const GET_EXCEPTIONS_CURRENT_PREVIOUS_FAILURE = 'GET_EXCEPTIONS_CURRENT_PREVIOUS_FAILURE';
export const GET_AUTHORIZATION_SEARCH_RESULTS_REQUEST = 'GET_AUTHORIZATION_SEARCH_RESULTS_REQUEST';
export const GET_AUTHORIZATION_SEARCH_RESULTS_SUCCESS = 'GET_AUTHORIZATION_SEARCH_RESULTS_SUCCESS';
export const GET_AUTHORIZATION_SEARCH_RESULTS_FAILURE = 'GET_AUTHORIZATION_SEARCH_RESULTS_FAILURE';
export const GET_AUTHORIZATIONS_SUBMITTED_REQUEST = 'GET_AUTHORIZATIONS_SUBMITTED_REQUEST';
export const GET_AUTHORIZATIONS_SUBMITTED_SUCCESS = 'GET_AUTHORIZATIONS_SUBMITTED_SUCCESS';
export const GET_AUTHORIZATIONS_SUBMITTED_FAILURE = 'GET_AUTHORIZATIONS_SUBMITTED_FAILURE';
export const GET_AUTHORIZATIONS_PENDING_REQUEST = 'GET_AUTHORIZATIONS_PENDING_REQUEST';
export const GET_AUTHORIZATIONS_PENDING_SUCCESS = 'GET_AUTHORIZATIONS_PENDING_SUCCESS';
export const GET_AUTHORIZATIONS_PENDING_FAILURE = 'GET_AUTHORIZATIONS_PENDING_FAILURE';
export const GET_CLIENT_CONTACT_REQUEST = 'GET_CLIENT_CONTACT_REQUEST';
export const GET_CLIENT_CONTACT_SUCCESS = 'GET_CLIENT_CONTACT_SUCCESS';
export const GET_CLIENT_CONTACT_FAILURE = 'GET_CLIENT_CONTACT_FAILURE';
export const GET_SURVEY_CURRENT_PREVIOUS_REQUEST = 'GET_SURVEY_CURRENT_PREVIOUS_REQUEST';
export const GET_SURVEY_CURRENT_PREVIOUS_SUCCESS = 'GET_SURVEY_CURRENT_PREVIOUS_SUCCESS';
export const GET_SURVEY_CURRENT_PREVIOUS_FAILURE = 'GET_SURVEY_CURRENT_PREVIOUS_FAILURE';
export const GET_AUTHS_BY_STATE_REQUEST = 'GET_AUTHS_BY_STATE_REQUEST';
export const GET_AUTHS_BY_STATE_SUCCESS = 'GET_AUTHS_BY_STATE_SUCCESS';
export const GET_AUTHS_BY_STATE_FAILURE = 'GET_AUTHS_BY_STATE_FAILURE';
export const GET_HOMESALE_STATUS_DATA_REQUEST = 'GET_HOMESALE_STATUS_DATA_REQUEST';
export const GET_HOMESALE_STATUS_DATA_SUCCESS = 'GET_HOMESALE_STATUS_DATA_SUCCESS';
export const GET_HOMESALE_STATUS_DATA_FAILURE = 'GET_HOMESALE_STATUS_DATA_FAILURE';
export const GET_STATES_REQUEST = 'GET_STATES_REQUEST';
export const GET_STATES_SUCCESS = 'GET_STATES_SUCCESS';
export const GET_STATES_FAILURE = 'GET_STATES_FAILURE';
export const GET_ALL_PROVINCES_REQUEST = 'GET_ALL_PROVINCES_REQUEST';
export const GET_ALL_PROVINCES_SUCCESS = 'GET_ALL_PROVINCES_SUCCESS';
export const GET_ALL_PROVINCES_FAILURE = 'GET_ALL_PROVINCES_FAILURE';
export const GET_ALL_COUNTRIES_REQUEST = 'GET_ALL_COUNTRIES_REQUEST';
export const GET_ALL_COUNTRIES_SUCCESS = 'GET_ALL_COUNTRIES_SUCCESS';
export const GET_ALL_COUNTRIES_FAILURE = 'GET_ALL_COUNTRIES_FAILURE';
export const GET_TABLEAU_REPORTING_URL_REQUEST = 'GET_TABLEAU_REPORTING_URL_REQUEST';
export const GET_TABLEAU_REPORTING_URL_SUCCESS = 'GET_TABLEAU_REPORTING_URL_SUCCESS';
export const GET_TABLEAU_REPORTING_URL_FAILURE = 'GET_TABLEAU_REPORTING_URL_FAILURE';

export const getBlogData = (feedUrl) => {
  return (dispatch) => {
    dispatch({ type: GET_BLOG_DATA_REQUEST });
    rssParser.parseURL(feedUrl)
      .then((res, err) => {
        dispatch({ type: GET_BLOG_DATA_SUCCESS, payload: res });
      })
      .catch((e) => {
        dispatch({ type: GET_BLOG_DATA_FAILURE });
      });
  };
};

export const getAuthorizationCurrentPrevious = () => {
  const clientId = getSelectedClientInformation()?.id;
  const divisionList = getSelectedDivisions()?.join(',');
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTHORIZATION_CURRENT_PREVIOUS_REQUEST, GET_AUTHORIZATION_CURRENT_PREVIOUS_SUCCESS, GET_AUTHORIZATION_CURRENT_PREVIOUS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizationFile/reporting/authorizationCurrentPrevious?clientId=${clientId}&divisionList=${divisionList}`,
      method: 'GET',
    },
  };
};

export const getExpenseCurrentPrevious = () => {
  const clientId = getSelectedClientInformation()?.id;
  const divisionList = getSelectedDivisions()?.join(',');
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EXPENSES_CURRENT_PREVIOUS_REQUEST, GET_EXPENSES_CURRENT_PREVIOUS_SUCCESS, GET_EXPENSES_CURRENT_PREVIOUS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizationFile/reporting/expenseCurrentPrevious?clientId=${clientId}&divisionList=${divisionList}`,
      method: 'GET',
    },
  };
};

export const getExceptionCurrentPrevious = () => {
  const clientId = getSelectedClientInformation()?.id;
  const divisionList = getSelectedDivisions()?.join(',');
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EXCEPTIONS_CURRENT_PREVIOUS_REQUEST, GET_EXCEPTIONS_CURRENT_PREVIOUS_SUCCESS, GET_EXCEPTIONS_CURRENT_PREVIOUS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizationFile/reporting/exceptionCurrentPrevious?clientId=${clientId}&divisionList=${divisionList}`,
      method: 'GET',
    },
  };
};

export const getAuthorizationSearchResults = () => {
  const clientId = getSelectedClientInformation()?.id;
  const divisionList = getSelectedDivisions()?.join(',');
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTHORIZATION_SEARCH_RESULTS_REQUEST, GET_AUTHORIZATION_SEARCH_RESULTS_SUCCESS, GET_AUTHORIZATION_SEARCH_RESULTS_FAILURE],
      authenticated: true,
      endpoint: 'api/authorizationFile/getAuthorizationSearchResults',
      method: 'POST',
      payload: { ClientID: clientId, DivisionList: divisionList },
    },
  };
};

export const getAuthorizationsSubmitted = () => {
  return {
    [CALL_API]: {
      types: [GET_AUTHORIZATIONS_SUBMITTED_REQUEST, GET_AUTHORIZATIONS_SUBMITTED_SUCCESS, GET_AUTHORIZATIONS_SUBMITTED_FAILURE],
      authenticated: true,
      endpoint: 'Authorization/GetAuthorizationsSubmitted',
      method: 'GET',
      options: {
        isClientSpecific: true,
        isDivisionSpecific: true,
      },
    },
  };
};

export const getAuthorizationsPending = () => {
  return {
    [CALL_API]: {
      types: [GET_AUTHORIZATIONS_PENDING_REQUEST, GET_AUTHORIZATIONS_PENDING_SUCCESS, GET_AUTHORIZATIONS_PENDING_FAILURE],
      authenticated: true,
      endpoint: 'Authorization/GetAuthorizationsPending',
      method: 'GET',
      options: {
        isClientSpecific: true,
        isDivisionSpecific: true,
      },
    },
  };
};

export const getClientContact = () => {
  // Use old API to fetch all contacts since V2 representative endpoint is failing
  // Will take the first contact for display on dashboard
  return {
    [CALL_API]: {
      types: [GET_CLIENT_CONTACT_REQUEST, GET_CLIENT_CONTACT_SUCCESS, GET_CLIENT_CONTACT_FAILURE],
      authenticated: true,
      endpoint: 'Client/GetClientContacts',
      method: 'GET',
      options: {
        isClientSpecific: true,
        isDivisionSpecific: true,
      },
    },
  };
};

export const getSurveyCurrentPrevious = () => {
  const clientId = getSelectedClientInformation()?.id;
  const divisionList = getSelectedDivisions()?.join(',');
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_SURVEY_CURRENT_PREVIOUS_REQUEST, GET_SURVEY_CURRENT_PREVIOUS_SUCCESS, GET_SURVEY_CURRENT_PREVIOUS_FAILURE],
      authenticated: true,
      endpoint: `api/authorizationFile/reporting/surveyCurrentPrevious?clientId=${clientId}&divisionList=${divisionList}`,
      method: 'GET',
    },
  };
};

export const getAuthorizationsByState = () => {
  const clientId = getSelectedClientInformation()?.id;
  const divisionList = getSelectedDivisions()?.join(',');
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AUTHS_BY_STATE_REQUEST, GET_AUTHS_BY_STATE_SUCCESS, GET_AUTHS_BY_STATE_FAILURE],
      authenticated: true,
      endpoint: `api/authorizationFile/reporting/getAuthorizationsByState?clientId=${clientId}&divisionList=${divisionList}`,
      method: 'GET',
    },
  };
};

export const getHomesaleStatusData = () => {
  const clientId = getSelectedClientInformation()?.id;
  const divisionList = getSelectedDivisions()?.join(',');
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_HOMESALE_STATUS_DATA_REQUEST, GET_HOMESALE_STATUS_DATA_SUCCESS, GET_HOMESALE_STATUS_DATA_FAILURE],
      authenticated: true,
      endpoint: `api/authorizationFile/reporting/homesalesAllTime?clientId=${clientId}&divisionList=${divisionList}`,
      method: 'GET',
    },
  };
};

export const getTableauReportingUrl = (reportPath) => {
  const clientId = getSelectedClientInformation()?.id;
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TABLEAU_REPORTING_URL_REQUEST, GET_TABLEAU_REPORTING_URL_SUCCESS, GET_TABLEAU_REPORTING_URL_FAILURE],
      authenticated: true,
      endpoint: `api/authorizationFile/reporting/getTableauUrl/${encodeURIComponent(reportPath)}?clientId=${encodeURIComponent(clientId || '')}`,
      method: 'POST',
    },
  };
};

export const getStates = () => {
  return {
    [CALL_API]: {
      types: [GET_STATES_REQUEST, GET_STATES_SUCCESS, GET_STATES_FAILURE],
      authenticated: true,
      endpoint: 'Resource/GetStates',
      method: 'GET',
    },
  };
};

export const getAllProvinces = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_PROVINCES_REQUEST, GET_ALL_PROVINCES_SUCCESS, GET_ALL_PROVINCES_FAILURE],
      authenticated: true,
      endpoint: 'api/enumerations/provinces',
      method: 'GET',
    },
  };
};

export const getAllCountries = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_ALL_COUNTRIES_REQUEST, GET_ALL_COUNTRIES_SUCCESS, GET_ALL_COUNTRIES_FAILURE],
      authenticated: true,
      endpoint: 'api/enumerations/countries',
      method: 'GET',
    },
  };
};